import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Toaster } from "@/components/ui/sonner";

export const Shell = () => {
    return (
        <div className="min-h-screen w-full flex bg-background text-foreground">
            <Sidebar />
            <main className="flex-1 min-w-0 flex flex-col">
                <Outlet />
            </main>
            <Toaster
                position="top-right"
                theme="system"
                toastOptions={{
                    style: {
                        background: "hsl(var(--card))",
                        color: "hsl(var(--card-foreground))",
                        border: "1px solid hsl(var(--border))",
                    },
                    className: "font-sans",
                }}
            />
        </div>
    );
};
